export const EMAIL_UPDATE_START = '/account-settings/email-update/start';
export const EMAIL_UPDATE_VERIFY_CURRENT_EMAIL =
  '/account-settings/email-update/verify-current-email';
export const EMAIL_UPDATE_SEND_MAGIC_LINK =
  '/account-settings/email-update/send-magic-link';
export const EMAIL_UPDATE_VERIFY_MAGIC_LINK =
  '/account-settings/email-update/verify-magic-link';
export const EMAIL_UPDATE_UPDATE_EMAIL =
  '/account-settings/email-update/update';
